/**
 * Escrituras de la lección deacon-2 (servicio como diácono). Texto de churchofjesuschrist.org.
 */
import type { Scripture } from './scriptures';

export const deacon2TrainingScripturesEs: Scripture[] = [
  {
    id: 'dc-58-26-28',
    reference: 'Doctrina y Convenios 58:26–28',
    text:
      'Porque he aquí, no conviene que yo mande en todas las cosas; porque el que es compelido en todo es un siervo perezoso y no sabio; por tanto, no recibe galardón alguno. De cierto digo que los hombres deben estar anhelosamente consagrados a una causa buena, y hacer muchas cosas de su propia voluntad y efectuar mucha justicia; porque el poder está en ellos, y en esto vienen a ser sus propios agentes. Y en tanto que los hombres hagan lo bueno, de ninguna manera perderán su recompensa.',
    verses: [
      {
        verse: 26,
        text: 'Porque he aquí, no conviene que yo mande en todas las cosas; porque el que es compelido en todo es un siervo perezoso y no sabio; por tanto, no recibe galardón alguno.',
      },
      {
        verse: 27,
        text: 'De cierto digo que los hombres deben estar anhelosamente consagrados a una causa buena, y hacer muchas cosas de su propia voluntad y efectuar mucha justicia;',
      },
      {
        verse: 28,
        text: 'porque el poder está en ellos, y en esto vienen a ser sus propios agentes. Y en tanto que los hombres hagan lo bueno, de ninguna manera perderán su recompensa.',
      },
    ],
    context: 'Servicio por propia voluntad y causa buena, sin esperar mandato en todo.',
  },
  {
    id: 'matthew-20-26-28',
    reference: 'Mateo 20:26–28',
    text:
      'Mas entre vosotros no será así, sino que el que quiera hacerse grande entre vosotros será vuestro servidor; y el que quiera ser el primero entre vosotros será vuestro siervo, así como el Hijo del Hombre no vino para ser servido, sino para servir y para dar su vida en rescate por muchos.',
    verses: [
      {
        verse: 26,
        text: 'Mas entre vosotros no será así, sino que el que quiera hacerse grande entre vosotros será vuestro servidor;',
      },
      {
        verse: 27,
        text: 'y el que quiera ser el primero entre vosotros será vuestro siervo,',
      },
      {
        verse: 28,
        text: 'así como el Hijo del Hombre no vino para ser servido, sino para servir y para dar su vida en rescate por muchos.',
      },
    ],
    context: 'Grandeza en el reino como servicio y siervo, al modo del Salvador.',
  },
  {
    id: 'alma-37-6-7',
    reference: 'Alma 37:6–7',
    text:
      'Ahora bien, tal vez pienses que esto es locura de mi parte; mas he aquí, te digo que por medio de cosas pequeñas y sencillas se realizan grandes cosas; y en muchos casos, los pequeños medios confunden a los sabios. Y el Señor Dios se vale de medios para realizar sus grandes y eternos designios; y por medios muy pequeños el Señor confunde a los sabios y realiza la salvación de muchas almas.',
    verses: [
      {
        verse: 6,
        text: 'Ahora bien, tal vez pienses que esto es locura de mi parte; mas he aquí, te digo que por medio de cosas pequeñas y sencillas se realizan grandes cosas; y en muchos casos, los pequeños medios confunden a los sabios.',
      },
      {
        verse: 7,
        text: 'Y el Señor Dios se vale de medios para realizar sus grandes y eternos designios; y por medios muy pequeños el Señor confunde a los sabios y realiza la salvación de muchas almas.',
      },
    ],
    context: 'Las obras del Señor a menudo por medios pequeños y sencillos.',
  },
  {
    id: 'dc-84-106',
    reference: 'Doctrina y Convenios 84:106',
    text: 'Y si de entre vosotros uno es fuerte en el Espíritu, lleve consigo al que es débil, a fin de que sea edificado con toda mansedumbre para que se haga fuerte también.',
    verses: [
      {
        verse: 106,
        text: 'Y si de entre vosotros uno es fuerte en el Espíritu, lleve consigo al que es débil, a fin de que sea edificado con toda mansedumbre para que se haga fuerte también.',
      },
    ],
    context: 'Edificar al débil con mansedumbre en el ministerio.',
  },
];
